import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { Action } from 'redux';
import ProjectCommentListComponent, { ProjectCommentsComponentProps } from './ProjectCommentList.component';
import ProjectComment from 'src/entities/ProjectComment';
import {
  getProjectComments,
  GetProjectCommentsAction
} from 'src/actions/project/comments/get/GetProjectComments.actions';
import {
  createProjectComment,
  CreateProjectCommentAction
} from 'src/actions/project/comments/create/CreateProjectComment.actions';
import * as createProjectCommentTypes from 'src/actions/project/comments/create/Types';
import { openModal, OpenModal } from 'src/actions/modal';
import CommentSuccessComponent from 'src/modules/project/partials/comments/CommentSuccess.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Project from 'src/entities/Project';

interface StateProps {
  isLogged: boolean;
  loggedUserData: number | null;
  projectComments: ProjectComment[];
}

interface DispatchProps {
  getProjectComments: (projectId: number) => Promise<GetProjectCommentsAction>;
  createProjectComment: (projectComment: ProjectComment, projectId: number) => Promise<CreateProjectCommentAction>;
  openModal: (component: JSX.Element, className: string) => void;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

interface State {
  newComment: ProjectComment;
}

class ProjectCommentListContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      newComment: new ProjectComment({
        id: undefined,
        body: '',
        authorId: undefined,
        authorName: undefined,
        projectId: this.props.project.id,
        createdAt: undefined,
        childComments: []
      }),
    };
  }

  public componentWillMount(): void {
    this.props.getProjectComments(this.props.project.id);
  }

  public render(): React.ReactNode {
    return (
      this.props.projectComments ?
        (
          <ProjectCommentListComponent {...this.getComponentProps()} />
        ) : null
    );
  }

  private handleChange(value: string): void {
    const newComment = this.state.newComment;
    newComment.body = value;
    this.setState({newComment: newComment});
  }

  private handleSubmit(): void {
    if (this.state.newComment) {
      this.props.createProjectComment(this.state.newComment, this.props.project.id).then((response: Action) => {
        if (response.type === createProjectCommentTypes.CREATE_PROJECT_COMMENT_SUCCESS) {
          this.props.openModal(
            <CommentSuccessComponent
              modalRef={this.props.modalRef}
            />,
            'large'
          );
          this.props.getProjectComments(this.props.project.id);
          this.handleChange('');
        }
      });
    }
  }

  private getComponentProps(): ProjectCommentsComponentProps {
    return {
      projectComments: this.props.projectComments,
      newComment: this.state.newComment.body,
      project: this.props.project,
      invest: this.props.invest,
      closedProject: this.props.closedProject,
      handleChange: (value: string) => this.handleChange(value),
      handleSubmit: () => this.handleSubmit(),
    };
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getProjectComments: (projectId: number): Promise<GetProjectCommentsAction> => (
    dispatch(getProjectComments(projectId))
  ),
  createProjectComment: (projectComment: ProjectComment, projectId: number): Promise<CreateProjectCommentAction> => (
    dispatch(createProjectComment(projectComment, projectId))
  ),
  openModal: (component: JSX.Element, className: string): OpenModal => (
    dispatch(openModal(component, className))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  isLogged: state.authentication.isLogged,
  loggedUserData: state.authentication.loggedUserData,
  projectComments: state.getProjectComments.comments,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectCommentListContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/comments/ProjectCommentList.container.tsx